/**
 * The raves somebody attends that have not ended, and those on right now (the soonest to end
 * first) — My raves' count and the LIVE button (the user, 2026-10-29). One rule for the phone's
 * bottom bar (`app/PlatformBar.tsx`) and both menus (`AppShell`, `UserShell`).
 */
export interface RaveTimes {
  attending?: boolean;
  gatesOpenAt?: string | null;
  endsAt?: string | null;
}

/**
 * The raves that count: attended and not over. The menus LIST exactly these under My raves (the
 * user, 2026-10-29: "my raves count 3 and shows 5" — only the coming ones; ended raves are on
 * the My raves page).
 */
export function comingRaves<T extends RaveTimes>(festivals: T[], now: number): T[] {
  return festivals.filter((f) => f.attending !== false && (!f.endsAt || Date.parse(f.endsAt) > now));
}

export function myRaveCounts<T extends RaveTimes>(festivals: T[], now: number): { upcoming: number; live: T[] } {
  const mine = comingRaves(festivals, now);
  const live = mine
    .filter((f) => f.gatesOpenAt && f.endsAt && Date.parse(f.gatesOpenAt) <= now)
    .sort((a, b) => Date.parse(a.endsAt!) - Date.parse(b.endsAt!));
  return { upcoming: mine.length, live };
}
